/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MigrateIssuerRequestBody,
  MigrateIssuerRequestBody$Outbound,
  MigrateIssuerRequestBody$outboundSchema,
} from "../components/migrateissuerrequestbody.js";

export type MigrateOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type MigrateOrganizationRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  migrateIssuerRequestBody: MigrateIssuerRequestBody;
};

/** @internal */
export type MigrateOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const MigrateOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    MigrateOrganizationRemoteSessionIssuerSecurity$Outbound,
    MigrateOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function migrateOrganizationRemoteSessionIssuerSecurityToJSON(
  migrateOrganizationRemoteSessionIssuerSecurity:
    MigrateOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    MigrateOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      migrateOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type MigrateOrganizationRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  MigrateIssuerRequestBody: MigrateIssuerRequestBody$Outbound;
};

/** @internal */
export const MigrateOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    MigrateOrganizationRemoteSessionIssuerRequest$Outbound,
    MigrateOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      migrateIssuerRequestBody: MigrateIssuerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        migrateIssuerRequestBody: "MigrateIssuerRequestBody",
      });
    }),
  );

export function migrateOrganizationRemoteSessionIssuerRequestToJSON(
  migrateOrganizationRemoteSessionIssuerRequest:
    MigrateOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    MigrateOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      migrateOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
